<template>
  <div id="content" v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction">
    </popup>
    <preview-popup
        :preview-data="previewData"
        :show-preview="preview"
        @hide-preview="hidePreview"
    />
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a class="btn btn_action btn_grey btn_preview"
             :title="'Náhled' | translate"
             @click.stop="showPreview"
             v-translate>Náhled</a>
          <a v-if="$_createActionAllowed"
             class="btn btn_action btn_grey btn_recipients"
             :title="'Převzít příjemce' | translate"
             @click.prevent.stop="duplicateRecipients"
             v-translate>Převzít příjemce</a>
          <a v-if="$_createActionAllowed"
             class="btn btn_action btn_grey btn_resend"
             :title="'Přeposlat oznámení' | translate"
             @click.prevent.stop="forwardMessage"
             v-translate>Přeposlat oznámení</a>
          <a v-if="$_loggedUser_operator_item_delete_action_allowed(this.entity.id_operator)"
             class="btn btn_action btn_delete"
             :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity"
             v-translate>Smazat</a>
        </p>
        <h1>{{entity.name}}</h1>
      </div>
      <div class="responsiveTabs r-tabs">
        <ul class="tabs">
          <li :class="getActiveTabClass('settings', false)">
            <a
                @click.prevent.stop="activateTab('settings', false)"
                v-translate>Vlastnosti
            </a>
          </li>
          <li v-if="$_loggedUser_action_allowed('subscribers')"
              :class="getActiveTabClass('recipients', false)">
            <a
                @click.prevent.stop="activateTab('recipients', false)"
                v-translate>Příjemci
            </a>
          </li>
        </ul>
        <div class="tabs_content" v-show="isActiveTab('settings', false)">
          <message-basic-info
          :entity="entity">
          </message-basic-info>
        </div>
        <div v-if="$_loggedUser_action_allowed('subscribers')"
            class="tabs_content"
             v-show="isActiveTab('recipients', false)">
          <section>
            <recipient-list></recipient-list>
          </section>
        </div>

      </div>

    </form>
  </div>
</template>

<script>
import MessageBasicInfo from "./settings/MessageBasicInfo"
import messages from "./mixins/messages"
import detailActions from "@/components/mixins/detail-actions"
import RecipientList from "./recipients/RecipientList"
import loggedUser from "../../mixins/global/logged-user";
import PreviewPopup from "./popup/PreviewPopup.vue";

export default {
  name: "MessageDetail",
  components: { PreviewPopup, RecipientList, MessageBasicInfo},
  mixins: [detailActions, messages, loggedUser],
  created: function (MessageService, OperatorService) {
    this.entityService = MessageService
    this.operatorService = OperatorService
    this.createdInit()
    this.getOperators()
  },
  data: function () {
    return {
      preview: false,
    }
  },
  computed: {
    previewData() {
      return {
        subject: this.translation.subject,
        short_body: this.translation.short_body,
        body: this.translation.body,
        type: this.entity.type
      }
    }
  },
  methods: {
    selectLanguage() {
      let tempTranslation = this.entity.translations[this.translation.language]
      this.translation.subject = tempTranslation.subject
      this.translation.short_body = tempTranslation.short_body
      this.translation.body = tempTranslation.body
    },
    submitForm(redirect = false) {
      this.updateEntity(this.prepareFormSubmitData(false), redirect)
    },
    _afterUpdateEntityActions() {
      this.reset()
    },
    forwardMessage(){
      this.$router.push({name: 'messageNew', params: {forward_message: this.entity.id}})
    },
    duplicateRecipients(){
      this.$router.push({name: 'messageNew', params: {duplicate_recipients: this.entity.id}})
    },
    showPreview() {
      this.preview = true
    },
    hidePreview() {
      this.preview = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/MessageDetail.vue